// app/javascript/controllers/department_managers_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["roleSelect"]

  load(event) {
    const departmentId = event.target.value
    if (!departmentId) return

    fetch(`/hris/employees/roles_by_department?department_id=${departmentId}`)
      .then(response => {
        if (!response.ok) throw new Error("Network error")
        return response.json()
      })
      .then(data => {
        this.roleSelectTarget.innerHTML = ""

        const defaultOption = document.createElement("option")
        defaultOption.value = ""
        defaultOption.text = "Select a Role"
        this.roleSelectTarget.appendChild(defaultOption)

        data.forEach(role => {
          const option = document.createElement("option")
          option.value = role.val
          option.text = `${role.txt}`
          this.roleSelectTarget.appendChild(option)
        })
      })
      .catch(error => {
        console.error("Fetch error:", error)
      })
  }
}
